export default __webpack_public_path__ + "static/winter17-ba0fffba44e1a0e8ef29af678f2ccc35.webp";